import api from "./axios";

export const getSmtpSettings = async () => {
    try {
        const response = await api.get("/api/v1/Smtp");
        return response.data;
    } catch (err) {
        throw err.response?.data || { message: "SMTP ayarları alınamadı!" };
    }
};

export const updateSmtpSettings = async (data) => {
    try {
        const response = await api.put("/api/v1/Smtp", data);
        return response.data;
    } catch (err) {
        throw err.response?.data || { message: "SMTP ayarları güncellenemedi!" };
    }
};
